import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-donatefund',
  templateUrl: './donatefund.component.html',
  styleUrls: ['./donatefund.component.css']
})
export class DonatefundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
